(function () {
  function init(root) {
    const wrap = root.querySelector('[data-slider]');
    if (!wrap) return;

    const track = wrap.querySelector('.track');
    const prev = wrap.querySelector('[data-prev]');
    const next = wrap.querySelector('[data-next]');
    if (!track) return;

    function step() {
      const first = track.querySelector('.card');
      if (!first) return 320;
      const gap = parseFloat(getComputedStyle(track).gap || '28');
      return first.getBoundingClientRect().width + gap;
    }

    let by = step();

    if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -by, behavior: 'smooth' }));
    if (next) next.addEventListener('click', () => track.scrollBy({ left:  by, behavior: 'smooth' }));

    if (window.ResizeObserver) {
      new ResizeObserver(() => { by = step(); }).observe(track);
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.reviews-new').forEach(init);
  }

  document.addEventListener('DOMContentLoaded', () => initAll(document));
  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
})();
